export const routes = {
    root: '/',
    home: '/home',
    productListing: '/product-listing/:id',
    productListingBanner: '/product-listing/:id/banner',
    categoryListing: '/category-listing/:id',
    categoryListingBanner: '/category-listing/:id/banner',
    productDetails: '/product-details/:id',
    singleStoreLocator: '/single-store-locator/:id',
    cart: '/cart',
    paymentMethod: '/payment-method',
    orders: '/orders',
    order: '/order/:id',
    ongoingOrder: '/ongoing-order/:id',
    banner: '/banner/:id',
    search: '/search',
    profile: '/profile',
    login: '/login',
    signup: '/signup',
    favouriteAddresses: '/favourite-addresses',
    helpCenter: '/help-center',
    tnc: '/tnc',
    privacy: '/privacy',
    editAddress: '/edit-address/:id',
    forgetPassword: '/forget-password',
    storeLocator: '/store-locator',
    notFound: '/notFound',
    submitEmail:'/submit-email',
    proceed:'/sign-in',
};
